import * as dateUtil from '@thoughtspot/date-format-util';
import { getDefaultCurrencyCode } from '@thoughtspot/number-format-util';
import { getSpecialFormatData } from '@thoughtspot/special-data-value-format';
import { getBucketization, isColumnValidForNumberFormatting, isDateColumn, isDateNumColumn, isFloat, isGeoColumn, isTimeColumn, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { FormatterTypeEnum } from './formatter/types';
import { AnswerColumnFormatType, CurrencyFormatType, } from './types/prism';
export const getFormatterTypeEnum = (col) => {
    let formatterType = FormatterTypeEnum.GENERIC_FORMATTER;
    if (isGeoColumn(col)) {
        formatterType = FormatterTypeEnum.GEO_FORMATTER;
    }
    else if (isColumnValidForNumberFormatting(col)) {
        formatterType = FormatterTypeEnum.NUMERIC_FORMATTER;
    }
    else if (isDateColumn(col)) {
        formatterType = FormatterTypeEnum.DATE_FORMATTER;
    }
    else if (isDateNumColumn(col)) {
        formatterType = FormatterTypeEnum.DATE_NUM_FORMATTER;
    }
    else if (isTimeColumn(col)) {
        formatterType = FormatterTypeEnum.TIME_FORMATTER;
    }
    return formatterType;
};
export const getEffectiveFormatType = (col) => col.formatType;
export const getEffectiveColumnFormatPattern = (col) => col.formatPattern;
export const getFormatPatternDecimalCount = (col) => isFloat(col) ? 2 : 0;
export const getFormatPattern = (col) => dateUtil.getFormatPatternForBucket(getBucketization(col)) ||
    col.format?.pattern ||
    getEffectiveColumnFormatPattern(col);
export const isPercentColumn = (col) => {
    if (_.isNil(getEffectiveFormatType(col)) ||
        getEffectiveFormatType(col) === AnswerColumnFormatType.None) {
        const formatPattern = getFormatPattern(col);
        return formatPattern && _.last(formatPattern) === '%';
    }
    return getEffectiveFormatType(col) === AnswerColumnFormatType.Percentage;
};
export const isEffectivelyPercent = (col) => isPercentColumn(col);
export const getColumnCurrencyInfo = (col) => {
    return col?.format?.currencyFormat;
};
export const getUniqueCurrencyCode = (col) => _.get(col, '_uniqueCurrencyCode');
export const isColumnCurrencyFormatType = (col) => col.format?.currencyFormat?.type === CurrencyFormatType.Column;
export const isCurrencyColumn = (col) => !_.isEmpty(col.format?.currencyFormat);
export const getLocale = (col) => {
    let locale = null;
    if (isCurrencyColumn(col) && !isColumnCurrencyFormatType(col)) {
        if (getColumnCurrencyInfo(col).type === CurrencyFormatType.IsoCode) {
            locale = getColumnCurrencyInfo(col).isoCode;
        }
        else if (getUniqueCurrencyCode(col)) {
            locale = getUniqueCurrencyCode(col);
        }
        else {
            locale = getDefaultCurrencyCode();
        }
    }
    return locale;
};
export const getColumnToFormatPatternType = (col) => col.formatType;
export const getTableColumnSpecialFormatData = (dataValue) => {
    const specialValue = getSpecialFormatData(dataValue);
    return specialValue;
};
//# sourceMappingURL=column-format-util.js.map